<template>
  <div class="personalmenu" v-if="personalInfo">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="24">
        <div class="title">
          <div class="title-img">
            <el-image
                style="width: 178px; height: 178px"
                :src="personalInfo?(role==3?(personalInfo.view1?imgPath+personalInfo.view1:'/image/personal/default_ava.jpg'):(personalInfo.photo_path?imgPath+personalInfo.photo_path:'/image/personal/morentx.png')):'/image/personal/morentx.png'"
                :preview-src-list="personalInfo?[(role==3?(personalInfo.view1?imgPath+personalInfo.view1:'/image/personal/default_ava.jpg'):(personalInfo.photo_path?imgPath+personalInfo.photo_path:'/image/personal/morentx.png'))]:['/image/personal/morentx.png']"
            ></el-image>
            <span v-if="personalInfo && role==2">{{ personalInfo.evaluator_rank|app_grade }}</span>
            <span v-if="personalInfo && role==1">{{ personalInfo.athlete_rank|grade }}</span>
          </div>
          <p
              style="padding: 0 10px"
          >{{
              personalInfo ? (role == 1 || role == 2 ? personalInfo.name : role == 3 ? personalInfo.mechanism_fullName : '') : ''
            }}</p>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24">
        <div class="operate">
          <div class="operate-t">
            <img src="/image/personal/icon.png"/>
            <label>{{ title }}</label>
          </div>
          <!-- 根据角色判断需要显示路由 -->
          <ul class="operate-b">
            <template
                v-for="(item,index) in (role==1?dataList:role==2?dataList1:role==3?dataList2:dataList3)"
            >
              <!-- <router-link :to="item.path" :key="index" > -->
              <li
                  :class="item.path == navPath ?'light':''"
                  :key="index"
                  style="cursor: pointer;"
                  @click="select(item.path)"
              >
                <!-- :to="personalInfo || item.name == '账户安全'?item.path:'/personal/completeInformation'" -->
                <img :src="item.src"/>
                <span>{{ item.name }}</span>
              </li>
              <!-- </router-link> -->
            </template>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GetDicData} from "@/api/admin/common.js";
//声明一个全局变量
let that;
export default {
  props: ["role"],
  computed: {
    ...mapGetters(["personalInfo"])
  },
  data() {
    return {
      menurole: "",
      title: "",
      name: "lucky",
      level: "一级运动员",
      // 运动员
      dataList: [
        {
          path: "/personal/gradeTestRecord",
          name: "等级测试记录",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/competitionApplication",
          name: "赛事申请",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/competitionApplicationRecord",
          name: "赛事申请记录",
          src: "/image/personal/icon4.png"
        },
        {
          path: "/personal/gradeCertificate",
          name: "等级证书",
          src: "/image/personal/icon5.png"
        },
        {
          path: "/personal/invoiceList",
          name: "发票记录",
          src: "/image/personal/icon6.png"
        },
        {
          path: "/personal/completeInformation",
          name: "基本信息",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/changePassword",
          name: "账户安全",
          src: "/image/personal/icon7.png"
        }
      ],
      // 考评员
      dataList1: [
        {
          path: "/personal/trainingRecord",
          name: "培训记录",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/workRecord",
          name: "工作记录",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/gradeCertificate",
          name: "等级证书",
          src: "/image/personal/icon4.png"
        },
        {
          path: "/personal/invoiceList",
          name: "发票记录",
          src: "/image/personal/icon6.png"
        },
        {
          path: "/personal/payRecord",
          name: "缴费记录",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/completeInformation",
          name: "基本信息",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/changePassword",
          name: "账户安全",
          src: "/image/personal/icon7.png"
        }
      ],
      // 测试机构
      dataList2: [
        {
          path: "/personal/completeInformation",
          name: "基本信息",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/qualificationApplication",
          name: "资质申请",
          src: "/image/personal/icon2.png"
        },
        {
          path: "/personal/contractList",
          name: "合同管理",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/testList",
          name: "测试列表",
          src: "/image/personal/icon3.png"
        },
        {
          path: "/personal/complaintHandling",
          name: "申诉处理",
          src: "/image/personal/icon4.png"
        },
        {
          path: "/personal/orderCenter",
          name: "订单中心",
          src: "/image/personal/icon3.png"
        },
        // {
        //    path: "/personal/pliceApplication",
        //    name: "考点申请",
        //    src: "/image/personal/icon5.png"
        // },
        {
          path: "/personal/changePassword",
          name: "账户安全",
          src: "/image/personal/icon7.png"
        }
      ],
      dataList3: [],
      navPath: "",
      certificate_grade: [],
      appraiser_grade: [],
      imgPath: window.apiObj.apiUrl
    };
  },
  watch: {
    $route() {
      this.checkRouterLocal();
    }
  },
  created() {
    this.checkRouterLocal();
    this.dicData();
    //判断进入的角色
    this.menurole = this.role;
    if (this.menurole == 1 || this.menurole == 2) {
      this.title = "个人中心";
    } else if (this.menurole == 3) {
      this.title = "机构主页";
    }
  },
  beforeCreate: function () {
    that = this;
  },
  methods: {
    // 检索当前路径
    checkRouterLocal() {
      // 查找当前路由下标高亮
      this.navPath = this.$route.meta.lightPath;
    },
    select(path) {
      if (!this.personalInfo) {
        this.$message({
          showClose: true,
          message: "请完善您的个人信息",
          type: "warning"
        });
      }
      if (this.role == 3) {
        if (
            path == "/personal/testList" ||
            //path == "/personal/complaintHandling" ||
            //path == "/personal/orderCenter" ||
            path == "/personal/pliceApplication"
        ) {
          if (
              this.personalInfo.approval_status == 1 ||
              this.personalInfo.approval_status == 2 ||
              this.personalInfo.approval_status == 4 ||
              !this.personalInfo.approval_status
          ) {
            this.$message({
              message: "请通过资质申请",
              type: "warning"
            });
            return false
          }
        }
      }
      this.$router.push({path: path});
    },
    dicData() {
      GetDicData({classCode: "certificate_grade"}).then(data => {
        if (data.data.result) {
          this.certificate_grade = data.data.result;
        }
      });
      GetDicData({classCode: "appraiser_grade"}).then(data => {
        if (data.data.result) {
          this.appraiser_grade = data.data.result;
        }
      });
    }
  },
  filters: {
    grade: data => {
      for (var i in that.certificate_grade) {
        if (that.certificate_grade[i].value == data) {
          return that.certificate_grade[i].label;
        }
      }
    },
    app_grade: data => {
      for (var i in that.appraiser_grade) {
        if (that.appraiser_grade[i].value == data) {
          return that.appraiser_grade[i].label;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.personalmenu {
  .title {
    background: #f3fafd;
    text-align: center;
    padding: 15px 0;
    margin-bottom: 20px;

    .title-img {
      position: relative;
      display: inline-block;

      span {
        position: absolute;
        bottom: 2px;
        right: 0px;
        background: #ffffff;
        border-radius: 5px;
        opacity: 0.8;
        font-size: 14px;
      }
    }
  }

  .operate {
    .operate-t {
      background: #f3fafd;
      text-align: center;
      padding: 20px 0;

      img {
        position: relative;
        top: 4px;
        left: -2px;
        width: 20px;
        height: 20.7px;
      }

      span {
        display: inline-block;
        top: -2px;
        font-weight: bold;
        color: #0058a1;
      }
    }

    .operate-b {
      background: #cde8fe;
      padding: 10px 0;
      text-align: center;

      li {
        position: relative;
        padding: 17px;
        background: #cde8fe;

        img {
          position: absolute;
          top: 8px;
          left: 35px;
          width: 16px;
          height: 18px;
        }

        span {
          position: absolute;
          top: 8px;
          left: 60px;
          color: #000;
          font-size: 14px;
        }

        @media screen and(max-width: 1024px) {
          img {
            left: 18px;
          }

          span {
            left: 40px;
          }
        }
      }

      .light {
        background: #8dc3ff;
      }
    }
  }
}

@media screen and(max-width: 1024px) {
  .personalmenu {
    .el-image {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>
